import {Action} from '../../common/types/common';
import {PayWarrantyResponseDTO} from '../types/mx/epics';

export const CHANGE_CARD_NUMBER_ACTION: Action = {
    name: 'CHANGE_CARD_NUMBER_ACTION',
    action: (cardNumber: string, ccvMaxLenght: number, ccvText: string, error: string = null) => ({
        cardNumber, ccvMaxLenght, ccvText, error,
        type: CHANGE_CARD_NUMBER_ACTION.name
    })
};

export const CHANGE_CARD_CCV_ACTION: Action = {
    name: 'CHANGE_CARD_CCV_ACTION',
    action: (ccv: string, error: string = null) => ({
        ccv, error,
        type: CHANGE_CARD_CCV_ACTION.name
    })
};

export const CHANGE_CARD_NAME_ACTION: Action = {
    name: 'CHANGE_CARD_NAME_ACTION',
    action: (cardName: string, error: string = null) => ({
        cardName, error,
        type: CHANGE_CARD_NAME_ACTION.name
    })
};

export const CHANGE_CARD_EXPIRATION_DATE_ACTION: Action = {
    name: 'CHANGE_CARD_EXPIRATION_DATE_ACTION',
    action: (cardExpirationDate: string, error: string = null) => ({
        cardExpirationDate, error,
        type: CHANGE_CARD_EXPIRATION_DATE_ACTION.name
    })
};

export const CHANGE_CARD_PAY_TYPE_DATE_ACTION: Action = {
    name: 'CHANGE_CARD_PAY_TYPE_DATE_ACTION',
    action: (payType: string, error: string = null) => ({
        payType, error,
        type: CHANGE_CARD_PAY_TYPE_DATE_ACTION.name
    })
};

export const SAVE_CREDIT_CARD_PAY_WARRANTY_DATA_ACTION: Action = {
    name: 'SAVE_CREDIT_CARD_PAY_WARRANTY_DATA_ACTION',
    action: (token: string) => ({
        token,
        type: SAVE_CREDIT_CARD_PAY_WARRANTY_DATA_ACTION.name
    })
};

export const SET_ERROR_CREDIT_CARD_DATA_ACTION: Action = {
    name: 'SET_ERROR_CREDIT_CARD_DATA_ACTION',
    action: (message: string, error: string) => ({
        message, error,
        type: SET_ERROR_CREDIT_CARD_DATA_ACTION.name
    })
};

export const SET_PAID_PAY_WARRANTY_ACTION: Action = {
    name: 'SET_PAID_PAY_WARRANTY_ACTION',
    action: () => ({
        type: SET_PAID_PAY_WARRANTY_ACTION.name
    })
};

export const GET_PAY_WARRANTY_ACTION = {
    name: 'GET_PAY_WARRANTY_ACTION',
    action: (warrantyId: string) => ({
        warrantyId,
        type: GET_PAY_WARRANTY_ACTION.name
    })
};

export const GOT_PAY_WARRANTY_ACTION = {
    name: 'GOT_PAY_WARRANTY_ACTION',
    action: (payWarranty: PayWarrantyResponseDTO, warrantyId: string) => ({
        payWarranty, warrantyId,
        type: GOT_PAY_WARRANTY_ACTION.name
    })
};